import script from "./modal-setting.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-setting.vue?vue&type=script&setup=true&lang=js"

import "./modal-setting.vue?vue&type=style&index=0&id=0248efd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0248efd4"]])

export default __exports__